// @ts-nocheck

export type TenantGetWithPlans = typeof TenantGetWithPlans[keyof typeof TenantGetWithPlans];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantGetWithPlans = {
  true: 'true',
  false: 'false',
} as const;
